import { ClientConfigObject } from "app/config/interfaces";
import React from "react";

import { getJsonFromUrl } from "app/main/functions";
import { Fund } from "app/funds/interfaces";
import { ETF } from "app/etf/interfaces";
import { Share } from "app/shares/interfaces";
import { Commodity } from "app/commodities";
import { StockIndex } from "app/stockIndexes/interfaces";
import { AnalysisDetail } from "app/analysis/interfaces";
import { NewsDetail } from "app/news/interfaces";
import { AssetClass } from "../../interfaces/enums";
import { chartPeriods } from "app/charts/types";
import { InstrumentLinkBlockProps } from "app/links/InstrumentLinkBlock/InstrumentLinkBlock";

export interface Store {
    url: string;
    config: ClientConfigObject;
    searchTerm?: string;
    instruments: {
        [key: string]: Share | ETF | Fund | Commodity | StockIndex;
    };
    topIndexes: InstrumentLinkBlockProps[];
    analysis: {
        [key: string]: AnalysisDetail;
    };
    news: {
        [key: string]: NewsDetail;
    };
    cache: {
        [key: string]: any;
    };
    getJsonFromUrl: <T>(url: string) => Promise<T>;
}

const linkSubstitute = "#";

export const DataProviderContext = React.createContext<Store>({
    url: "",
    config: {
        apiURL: "",
        basePath: "",
        urlPathPrefixNews: "",
        urlPathPrefixStocks: "",
        newsUrl: linkSubstitute,
        marketOverViewUrl: linkSubstitute,
        financeIntroductionUrl: linkSubstitute,
        commoditiesLandingUrl: linkSubstitute,
        sharesLandingUrl: linkSubstitute,
        fondsLandingUrl: linkSubstitute,
        etfsLandingUrl: linkSubstitute,
        indizesLandingUrl: linkSubstitute,
        defaultPeriods: {
            [AssetClass.Share]: chartPeriods.INTRADAY,
            [AssetClass.Commodity]: chartPeriods.INTRADAY,
            [AssetClass.ExchangeRate]: chartPeriods.INTRADAY,
            [AssetClass.ETF]: chartPeriods.INTRADAY,
            [AssetClass.Index]: chartPeriods.INTRADAY,
            [AssetClass.Fund]: chartPeriods.THREE_YEARS
        }
    },
    instruments: {},
    topIndexes: [],
    analysis: {},
    news: {},
    cache: {},
    getJsonFromUrl
});

// @ts-ignore
const Provider = ({ value, children }) => (
    <DataProviderContext.Provider value={{ ...value, cache: value.cache || {}, getJsonFromUrl }}>
        {children}
    </DataProviderContext.Provider>
);

export default Provider;
